/**
 * ConnectPath Color System
 * 
 * This file defines the color palette for the ConnectPath design system.
 * Colors are organized into primary, secondary, neutral, and semantic categories.
 */

// Primary Colors
export const primary = {
  50: '#E6F7FF',
  100: '#BAE7FF',
  200: '#91D5FF',
  300: '#69C0FF',
  400: '#40A9FF',
  500: '#1890FF', // Primary brand color
  600: '#096DD9',
  700: '#0050B3',
  800: '#003A8C',
  900: '#002766',
};

// Secondary Colors
export const secondary = {
  50: '#F0F5FF',
  100: '#D6E4FF',
  200: '#ADC6FF',
  300: '#85A5FF',
  400: '#597EF7',
  500: '#2F54EB', // Secondary brand color
  600: '#1D39C4',
  700: '#10239E',
  800: '#061178',
  900: '#030852',
};

// Neutral Colors
export const neutral = {
  50: '#FAFAFA',
  100: '#F5F5F5',
  200: '#EEEEEE',
  300: '#E0E0E0',
  400: '#BDBDBD',
  500: '#9E9E9E',
  600: '#757575',
  700: '#616161',
  800: '#424242',
  900: '#212121',
};

// Semantic Colors
export const semantic = {
  success: {
    light: '#B7EB8F',
    default: '#52C41A',
    dark: '#389E0D',
  },
  warning: {
    light: '#FFE58F',
    default: '#FAAD14',
    dark: '#D48806',
  },
  error: {
    light: '#FFCCC7',
    default: '#FF4D4F',
    dark: '#CF1322',
  },
  info: {
    light: '#91D5FF',
    default: '#1890FF',
    dark: '#096DD9',
  },
};

// Theme Colors
export const theme = {
  // Background colors
  background: {
    primary: '#FFFFFF',
    secondary: neutral[50],
    tertiary: neutral[100],
  },
  
  // Text colors
  text: {
    primary: neutral[900],
    secondary: neutral[700],
    tertiary: neutral[500],
    disabled: neutral[400],
    inverse: '#FFFFFF',
  },
  
  // Border colors
  border: {
    light: neutral[200],
    default: neutral[300],
    dark: neutral[400],
  },
  
  // Action colors
  action: {
    active: primary[500],
    hover: primary[400],
    selected: primary[100],
    disabled: neutral[300],
    disabledBackground: neutral[100],
    focus: primary[100],
  },
};

// Export all colors
const colors = {
  primary,
  secondary,
  neutral,
  semantic,
  theme,
};

export default colors;